import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Inject, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, startWith, switchMap } from 'rxjs';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.scss'] 
})
export class ProductFilterComponent implements OnInit{ 
  @Output() filterApplied = new EventEmitter<any>();
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  announcer = inject(LiveAnnouncer);
  productFilterForm!:FormGroup;
  status:any=[{label:'Active',value:'active'},{label:'Inactive',value:'inactive'}];
  createdBy:any=[];
  oems:any=[];
  categories:any=[];
  users:any[] = [];
  isEditMode = false;
  selectedOEM ='';
  addOnBlur = true;
  selectable = true;
  removable = true;
  tertiaryCategories: any= [];
  secondaryCategories: any[] = [];
  quaternaryCategories: any = []; 
  filteredCategories: any[] = [];
  primaryCategories: any[] = [];
  filteredSecondaryCategories: any;
  filteredTertiaryCategories: any;
  filteredQuaternaryCategories: any;
  payloadCategoryId: any = '';
  filterCategoryName: any = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    public dialogRef: MatDialogRef<any>,
    private categoryService:CategoryService, 
    private fb:FormBuilder,
    private allProductService : AllProductService
  )  {
    this.productFilterForm = this.fb.group({
      status:[''],
      createdBy:[''],
      oem:[''],
      category:[''],
      startWith: [''],
      startDate: [''],
      endDate: [''],
      primaryCategory: [''],
      secondaryCategory: [''],
      tertiaryCategory: [''],
      quaternaryCategory: ['']
    });
  }

  @Output() clearFilters = new EventEmitter<void>();

  ngOnInit(): void {
   
    if(this.data) {
      this.productFilterForm.get('startWith')?.setValue('');
      this.productFilterForm.get('status')?.setValue(this.data.status);
      this.productFilterForm.get('createdBy')?.setValue(this.data.createdBy ? this.data.createdBy.id : '');
      this.productFilterForm.get('oem')?.setValue(this.data.oemId);
      this.productFilterForm.get('category')?.setValue(this.data.categoryId ? this.data.categoryId.id : '');
      this.productFilterForm.get('primaryCategory')?.setValue(this.data.primaryCategory ? this.data.primaryCategory.id : '');
      this.productFilterForm.get('secondaryCategory')?.setValue(this.data.secondaryCategory ? this.data.secondaryCategory.id : '');
      this.productFilterForm.get('tertiaryCategory')?.setValue(this.data.tertiaryCategory ? this.data.tertiaryCategory.id : '');
      this.productFilterForm.get('quaternaryCategory')?.setValue(this.data.quaternaryCategory ? this.data.quaternaryCategory.id : '');
      this.productFilterForm.get('startDate')?.setValue(this.data.startDate ? this.data.startDate: '');
      this.productFilterForm.get('endDate')?.setValue(this.data.endDate ? this.data.endDate: '');

      if(this.data.oemId) {
        this.selectedOEM = this.data.oemId.companyName;
        this.isEditMode = true;
      }
     
      
    }
    
    this.getAllUsers();
    // this.getCategory();
    this.getCategoryById();

    this.productFilterForm.get('startWith')?.valueChanges.subscribe(value => {
      this.getOEM(value)
    }); 
  }

  loadOEM() {
    this.getOEM('');
  }

  getAllUsers() {
    this.allProductService.getAllUsers().subscribe({
      next: (response) => {
        if(response.data.length > 0) {
          this.users = response.data;
        } 
      },
      error: (error) => {
       
      }
    });
  }

  getOEM(startWith : string) {
    this.allProductService.getOEMs(0,10, startWith).subscribe({
      next: (response) => {
        this.oems = response.data;
      },
      error: (error) => {
       
      }
    });
  }

  onOEMChange(event : any) {
    this.selectedOEM = event.option.value.companyName
    this.productFilterForm.get('oem')?.setValue( event.option.value);
    this.productFilterForm.get('startWith')?.setValue('');
    this.isEditMode = false;
  }

  removeOEM() {
    this.selectedOEM = '';
    this.productFilterForm.get('oem')?.setValue(null);
    this.productFilterForm.get('startWith')?.setValue('');
    this.isEditMode = false;
  }

  addOEM(event: MatChipInputEvent) {
    event.chipInput!.clear();
  }

  // getCategory() {
  //   this.categoryService.getAllCategories().subscribe({
  //     next: (response) => {
  //       if(response.data.length > 0) {
  //         this.categories = response.data;
  //         this.filteredCategories=this.categories
  //       } 
  //     },
  //     error: (error) => {
      
  //     }
  //   });
  // }

  getCategoryById() {
    const categoryId = this.productFilterForm.get('category')?.value?.id;
    this.categoryService.getCategoriesbyIdForProductFilter(null).subscribe({
      next: (response) => {
        if(response.data.length > 0) {
          this.categories = response.data;
          this.filteredCategories=this.categories
        } 
      },
      error: (error) => {
      
      }
    });
  }

  onPrimaryCategoryChange(categoryName: any): void {
    const categoryId = this.categories.find((c: { name: any; }) => c.name === categoryName)?.id;
    this.payloadCategoryId = categoryId;
    this.filterCategoryName = categoryName;
    
    this.categoryService.getCategoriesbyIdForProductFilter(categoryId).subscribe((response) => {
      const data = response?.data;
      this.secondaryCategories = data;
        
      this.filteredSecondaryCategories = this.secondaryCategories;   
      this.tertiaryCategories = [];
      this.quaternaryCategories = [];
    });
  }

  onSecondaryCategoryChange(categoryName: any): void {   
    const categoryId = this.secondaryCategories.find((c: { name: any; }) => c.name === categoryName)?.id;
    this.payloadCategoryId = categoryId;
    this.filterCategoryName = categoryName;  
    this.categoryService.getCategoriesbyIdForProductFilter(categoryId).subscribe((response) => {
      const data = response?.data;
      this.tertiaryCategories = data;
      this.filteredTertiaryCategories = this.tertiaryCategories;
      this.quaternaryCategories = [];
    });
  }

 getSecondaryCategoryDropdown(event: any) {
    const inputValue = event.target?.value?.toLowerCase() || '';
    this.filteredSecondaryCategories = this.secondaryCategories?.filter((category : any)=>{
      return category?.name?.toLowerCase().includes(inputValue);
    })
  }

  getCategoryDropdown(event: any) {
    const inputValue = event.target?.value?.toLowerCase() || '';
    this.filteredCategories = this.categories?.filter((category : any)=>{
      return category?.name?.toLowerCase().includes(inputValue);
    })
  }

  getTertiaryCategoryDropdown(event: any) {
    const inputValue = event.target?.value?.toLowerCase() || '';
    this.filteredTertiaryCategories = this.tertiaryCategories?.filter((category : any)=>{
      return category?.name?.toLowerCase().includes(inputValue);
    })
  }

  getQuaternaryCategoryDropdown(event: any) {
    const inputValue = event.target?.value?.toLowerCase() || '';
    this.filteredQuaternaryCategories = this.quaternaryCategories?.filter((category : any)=>{
      return category?.name?.toLowerCase().includes(inputValue);
    })
  }

  onTertiaryCategoryChange(categoryName: any): void {
    const categoryId = this.tertiaryCategories.find((c: { name: any; }) => c.name === categoryName)?.id;
    this.payloadCategoryId = categoryId;
    this.filterCategoryName = categoryName;
    this.categoryService.getCategoriesbyIdForProductFilter(categoryId).subscribe((response) => {
      const data = response?.data;
      this.quaternaryCategories = data;      
      this.filteredQuaternaryCategories = this.quaternaryCategories;
    });
  }
  onQuaternaryCategoryChange(categoryName: any): void {
    const categoryId = this.quaternaryCategories.find((c: { name: any; }) => c.name === categoryName)?.id;
    this.payloadCategoryId = categoryId;
    this.filterCategoryName = categoryName;
  }

  filterProduct(){
    const formData = this.productFilterForm.value;
  //   if (!formData.oem && !formData.category && !formData.status) {
  //     Swal.fire({
  //         icon: 'warning',
  //         title: 'Missing Filters',
  //         text: 'Please select at least one filter!',
  //         confirmButtonText: 'OK',
  //     });
  //     return;
  // }
    const createdBy = this.users.find((u: { id: any; }) => u.id === formData.createdBy);

    const payload = {
        oemId: formData.oem,
        categoryId: this.payloadCategoryId || '',
        categoryName: this.filterCategoryName || '',
        // status: formData.status,
        createdBy: createdBy === undefined ? '' : createdBy.id,
        startDate: formData.startDate,
        endDate: formData.endDate
    }; 
   this.dialogRef.close(JSON.parse(JSON.stringify(payload)));
  }

  clearFilter(){
    this.productFilterForm.reset();
    // this.chips
    this.clearFilters.emit(this.productFilterForm?.value);
  }

  closeDialog(){
    this.productFilterForm.reset();
    this.clearFilters.emit(this.productFilterForm?.value);
    this.dialogRef.close(null);
  }

get chips(): string[] {
  const formData = this.productFilterForm.value;
  const chips: string[] = [];

  if (formData.oem) {
    chips.push(formData.oem.companyName);
  }

  const categoryFields = [
    { field: 'primaryCategory', list: this.categories },
    { field: 'secondaryCategory', list: this.secondaryCategories },
    { field: 'tertiaryCategory', list: this.tertiaryCategories },
    { field: 'quaternaryCategory', list: this.quaternaryCategories }
  ];

  categoryFields.forEach(({ field, list }) => {
    const categoryId = formData[field];
    if (categoryId && list?.length) {
      const category = list.find((c: { id: any, name: any }) => c.name === categoryId);
      if (category) {
        chips.push(category.name);
      }
    }
  });

  if (formData.startDate && formData.endDate) {
    const startDate = new Date(formData.startDate);
    const endDate = new Date(formData.endDate);
    chips.push(
      `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()} - ${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`
    );
  }

  return chips;
}

removeChip(chip: string): void {
  const formData = this.productFilterForm.value;

  if (formData.oem && formData.oem.companyName === chip) {
    this.productFilterForm.patchValue({ oem: null });
  }
  if (formData.startDate && formData.endDate) {
    const startDate = new Date(formData.startDate);
    const endDate = new Date(formData.endDate);
    const dateChip = `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()} - ${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`;
    if (dateChip === chip) {
      this.productFilterForm.patchValue({ startDate: null, endDate: null });
    }
  }

  const categoryFields = [
    { field: 'primaryCategory', list: this.categories },
    { field: 'secondaryCategory', list: this.secondaryCategories },
    { field: 'tertiaryCategory', list: this.tertiaryCategories },
    { field: 'quaternaryCategory', list: this.quaternaryCategories }
  ];

  categoryFields.forEach(({ field, list }) => {
    const categoryId = formData[field];
    if (categoryId && list?.length) {
      const category = list.find((c: { id: any; name: any }) => c.name === chip);
      if (category) {
        this.productFilterForm.get(field)?.reset();
      }
    }
  });
}
}
